import React, {useContext, useEffect, useState} from 'react';
import {ContainerTitleTable} from "../../../components/Containers/ContainerTitleTable";
import {consultarNodoArbol} from "../../../api/contrato.service";
import {Tree} from 'primereact/tree';

import {AppContext} from "../../../context/appContext";
import {types} from "../../../shared/types/types";

export const ArbolClientes = () => {
    const { dispatch} = useContext(AppContext);
    const [nodes, setNodes] = useState(null);
    const [selectedKey, setSelectedKey] = useState(null);
    const asignarNode = async () => {
        const response = await consultarNodoArbol()
        return await response.data;
    }

    useEffect(() => {
        if (nodes === null) {
            asignarNode().then(r => setNodes(r.data))
        }
        return () => {

        };
    }, []);


    const   onNodeSelect = (node) => {
        const {disabled, key} = node.node;
        if (disabled === 'I') {
            const action = {
                type: types.contratomarcoId,
                payload: key
            }
            dispatch(action)

        }
    }

    return (
        <>
            <ContainerTitleTable>
                Contratos por cliente
            </ContainerTitleTable>
            <Tree value={nodes}
                  contentStyle={{fontSize: ".9em" }}
                  selectionMode="single"
                  selectionKeys={selectedKey}
                  onSelectionChange={e => setSelectedKey(e.value)}
                  onSelect={onNodeSelect}
                  filter filterMode="lenient"/>
        </>
    );
};

